import React from 'react';
import { DisposalOptions } from './DisposalOptions';

const statistics = [
  {
    value: "$250B +",
    description: "Excess Inventory is a $250 + Billion Problem in the U.S. Alone"
  },
  {
    value: "61%",
    description: "Confirm they struggle with excess inventory: 62% of Large Retailers and 42% of SMEs"
  },
  {
    value: "40%",
    description: "of clothes made each year--60 Billion garments are not sold"
  },
  {
    value: "88%",
    description: "of major fashion brands do not disclose their annual production volumes masking the true extent of overproduction."
  }
];

export function StatisticsSection() {
  return (
    <>
      <div className="tw-flex tw-flex-col tw-mt-20 md:tw-mt-36 tw-mx-auto" style={{maxWidth: "1293px"}}>
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-5 tw-px-4">
          <div 
            className="column-1-wrapper md:tw-h-auto tw-flex tw-flex-col" 
            style={{ position: "relative" }} >
            <div 
              className='column-1 tw-flex tw-flex-col tw-sticky'
              style={{ top: "20px" }} >
              <h2 className="tw-pr-11 tw-text-5xl md:tw-text-6xl tw-mb-48 tw-text-neutral-800">
                Massive Problem, Limited Brand-Aligned Solutions
              </h2>
              <img
                className='tw-hidden md:tw-block'
                loading="lazy"
                src="https://expertpeople.imgix.net/assets/images/big-arrow-rigth.svg"
                style={{width: "252px"}}
              />
            </div>
          </div>
          <div className='column-2 tw-flex tw-flex-col tw-gap-20'>
            {statistics.map((stat, index) => (
              <div 
                key={index} 
                className="tw-flex tw-flex-col"
                role="presentation"
              >
                <div className="tw-text-6xl md:tw-text-9xl tw-tracking-tighter tw-leading-tight tw-text-dark-green tw-mb-6">
                  {stat.value}
                </div>
                <div className="tw-text-2xl tw-leading-snug tw-text-neutral-800">
                  {stat.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <DisposalOptions />
    </>
  );
}
